import React from 'react';
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import UsageChart from "@/components/UsageChart";

interface UsageSectionProps {
  usage: number;
  limit: number;
}

const UsageSection: React.FC<UsageSectionProps> = ({ usage, limit }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>今月の利用状況</CardTitle>
      </CardHeader>
      <CardContent className="flex justify-center px-4">
        <UsageChart usage={usage} limit={limit} />
      </CardContent>
    </Card>
  );
};

export default UsageSection;
